module.exports = __webpack_public_path__ + "img/service-trivia-img.a5aabba3.png";